import type { RequestConfig } from '@customTypes/index';
import type { Role } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetProfilesParams = RequestConfig;

type GetProfilesResponse = {
  role: Role;
  profileIds: number[];
};

export const getProfiles = async ({ config }: GetProfilesParams) =>
  api.get<GetProfilesResponse>('/api/account/profiles', config);
